module.exports = __webpack_public_path__ + "static/media/ar.f4201798.png";